var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._g({key:_vm.icon,class:['dynamic-icon', _vm.type, _vm.className],attrs:{"title":_vm.title}},Object.assign({}, _vm.$listeners)),[_c('i',{class:_vm.icon})])}
var staticRenderFns = []

export { render, staticRenderFns }